import PropTypes from 'prop-types';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { Forms } from './constants';

const { TaxType } = Constants;

export const DataManagementPropTypes = PropTypes.shape({
  callBack: PropTypes.func,
  dataFetch: PropTypes.func,
});

export const AddressPropTypes = PropTypes.shape({
  Country: PropTypes.string,
  Line1: PropTypes.string,
  Line2: PropTypes.string,
  Line3: PropTypes.string,
  Line4: PropTypes.string,
  StateOrProvince: PropTypes.string,
  City: PropTypes.string,
  PostalCode: PropTypes.string,
  IsValid: PropTypes.bool,
  ValidationVersionId: PropTypes.number,
});

export const FormControlPropTypes = PropTypes.shape({
  visible: PropTypes.bool,
  optional: PropTypes.bool,
  label: PropTypes.string,
});

export const FormControlsShape = PropTypes.shape({
  [Forms.AddressForm]: FormControlPropTypes,
  [Forms.BusinessName]: FormControlPropTypes,
  [Forms.BusinessAddressSelector]: FormControlPropTypes,
  [Forms.CountrySelector]: FormControlPropTypes,
  [Forms.TaxForm]: FormControlPropTypes,
  [Forms.CurrencySelector]: FormControlPropTypes,
  [Forms.PhoneNumber]: FormControlPropTypes,
  [Forms.TimeZone]: FormControlPropTypes,
});

export const TaxPropTypes = PropTypes.arrayOf(PropTypes.shape({
  Key: PropTypes.string.isRequired,
  Value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
}));

export const PassiveErrorShape = PropTypes.shape({
  showErrorOnPassiveMessages: PropTypes.bool,
  passiveMessages: PropTypes.arrayOf(PropTypes.string),
});

export const PassiveErrorsShapes = PropTypes.shape({
  [Forms.BusinessName]: PropTypes.shape({
    BusinessName: PassiveErrorShape,
    Outer: PassiveErrorShape,
  }),
  [Forms.TaxForm]: PropTypes.shape({
    [TaxType.GSTINNumber]: PassiveErrorShape,
    [TaxType.PANNumber]: PassiveErrorShape,
    Outer: PassiveErrorShape,
  }),
  [Forms.AddressForm]: PropTypes.shape({
    Line1: PassiveErrorShape,
    Line2: PassiveErrorShape,
    Line3: PassiveErrorShape,
    Line4: PassiveErrorShape,
    PostalCode: PassiveErrorShape,
    City: PassiveErrorShape,
    StateOrProvince: PassiveErrorShape,
    Country: PassiveErrorShape,
    Outer: PassiveErrorShape,
  }),
});

export const helpPopupIdsShape = PropTypes.shape({
  [Forms.CountrySelector]: PropTypes.object,
  [Forms.BusinessName]: PropTypes.object,
  [Forms.BusinessAddressSelector]: PropTypes.object,
  [Forms.CurrencySelector]: PropTypes.object,
  [Forms.TimeZone]: PropTypes.object,
});

export const AblInfoShapes = PropTypes.shape({
  addressData: AddressPropTypes,
  businessNameData: PropTypes.object,
  countryCode: PropTypes.string,
  phoneNumberData: PropTypes.object,
  taxData: PropTypes.shape({
    data: TaxPropTypes,
  }),
  timeZoneData: PropTypes.object,
  currencyData: PropTypes.object,
  prefillAddressId: PropTypes.number,
  isValid: PropTypes.bool,
  alwaysShowError: PropTypes.bool,
});
